import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider, useAuth } from './context/AuthContext';

// Public Pages
import HomePage from './pages/public/HomePage';
import { AnnouncementsPage, AnnouncementDetailPage } from './pages/public/AnnouncementsPage';
import AdeverintaPage from './pages/public/AdeverintaPage';
import DonationsPage from './pages/public/DonationsPage';
import ContactPage from './pages/public/ContactPage';
import AboutPage from './pages/public/AboutPage';

// Admin Pages
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPostsPage from './pages/admin/AdminPostsPage';
import AdminPostEditor from './pages/admin/AdminPostEditor';
import AdminAdeverintaPage from './pages/admin/AdminAdeverintaPage';
import AdminAdeverintaDetail from './pages/admin/AdminAdeverintaDetail';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-islamic-pearl flex items-center justify-center">
        <div className="animate-pulse text-islamic-teal">Loading...</div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

// App Routes
const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/annonces" element={<AnnouncementsPage />} />
      <Route path="/annonces/:id" element={<AnnouncementDetailPage />} />
      <Route path="/adeverinta" element={<AdeverintaPage />} />
      <Route path="/dons" element={<DonationsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/about" element={<AboutPage />} />
      
      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/posts"
        element={
          <ProtectedRoute>
            <AdminPostsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/posts/:id"
        element={
          <ProtectedRoute>
            <AdminPostEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/adeverinta"
        element={
          <ProtectedRoute>
            <AdminAdeverintaPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/adeverinta/:id"
        element={
          <ProtectedRoute>
            <AdminAdeverintaDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute>
            <AdminUsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/settings"
        element={
          <ProtectedRoute>
            <AdminSettingsPage />
          </ProtectedRoute>
        }
      />
      
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
